import { getReference, setReference } from "lib/@hooks/use-reference"
import { ReferenceValueUpdated } from "event-definitions"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { AuthoringCollapseAllToggle } from "authoring/components/authoring-collapse-all-toggle"
import { createDraftId } from "../../lib/project-utils"

export function AmendsViewAllToggle({ projectId, scheduleId, keyLabel = "authorNotes" }) {
    const draftId = createDraftId(projectId, scheduleId)
    const key = `${keyLabel}-expanded-${draftId}`
    const refresh = useRefresh(noChange)
    ReferenceValueUpdated(key).useEvent(refresh)
    const bulkExpanded = getReference()[key] ?? false
    return (
        <AuthoringCollapseAllToggle
            expanded={bulkExpanded}
            onToggle={toggleBulk}
            label="author notes"
            dataCy="view-author-notes-toggle"
        />
    )

    function toggleBulk() {
        setReference({ [key]: !bulkExpanded }, false)
        ReferenceValueUpdated(key).raiseOnce()
    }
}
